import Home from './insights-home/insights-home';
import Article from './article';

export default {
  Home,
  Article

}